import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface TomePageDto {
	id: string;
	tomeId: string;
	tomeName: string | null;
	name: string;
	content: string | null;
	imageAssetId: string | null;
	foundryId: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface TomePagesListResponse {
	tomePages: TomePageDto[];
	total: number;
}

export interface TomePageGetResponse {
	tomePage: TomePageDto;
}

export interface UpsertTomePageRequest {
	tomeId: string;
	name: string;
	content?: string | null;
	imageAssetId?: string | null;
	foundryId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class TomePagesService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string, args?: { q?: string; tomeId?: string }): Observable<TomePagesListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (args?.q) params = params.set('q', args.q);
		if (args?.tomeId) params = params.set('tomeId', args.tomeId);
		return this.http.get<TomePagesListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tome-pages`, { params });
	}

	get(worldId: string, tomePageId: string): Observable<TomePageGetResponse> {
		return this.http.get<TomePageGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tome-pages/${tomePageId}`);
	}

	create(worldId: string, request: UpsertTomePageRequest): Observable<TomePageGetResponse> {
		return this.http.post<TomePageGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tome-pages`, {
			TomeId: request.tomeId,
			Name: request.name,
			Content: request.content ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	update(worldId: string, tomePageId: string, request: UpsertTomePageRequest): Observable<TomePageGetResponse> {
		return this.http.put<TomePageGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tome-pages/${tomePageId}`, {
			TomeId: request.tomeId,
			Name: request.name,
			Content: request.content ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	delete(worldId: string, tomePageId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tome-pages/${tomePageId}`);
	}
}
